import React from 'react';
import Guia from '../../components/guia/guia'; 

const GuiaPage = () => {
    return (
        <main>
            <Guia />
        </main>
    );
};

export default GuiaPage;